import { useSelector } from "react-redux";
import { ItemTypes } from "../../../abstract/controller/enum/dnd/ItemTypes";
import { getSize } from "../../../abstract/redux/slice/statusSlice";
import styles from "./DragOverlay.module.scss";

export function DragOverlay({ type, isEmpty = false, isVisible = false, adjust }) {
  const { width, height } = useSelector(getSize);

  const getClass = () => {
    if (isEmpty) {
      if (type === ItemTypes.CHOICE) {
        return `${styles["panel"]} ${styles["panel-empty-choice"]}`;
      } else if (type === ItemTypes.PARAMETER) {
        return `${styles["panel"]} ${styles["panel-empty-param"]}`;
      } else {
        return `${styles["panel"]} ${styles["panel-empty-fun"]}`;
      }
    } else {
      if (type === ItemTypes.CHOICE) {
        return `${styles["panel"]} ${styles["panel-choice"]}`;
      } else if (type === ItemTypes.PARAMETER) {
        return `${styles["panel"]} ${styles["panel-param"]}`;
      } else {
        return `${styles["panel"]} ${styles["panel-fun"]}`;
      }
    }
  };

  if (!isVisible) {
    return null;
  }

  const getDimension = () => {
    if (!isEmpty) {
      if (type === ItemTypes.CHOICE) {
        return { height: `${height}px` }
      }
    }

    if (adjust) {
      return { width: `100%`, height: `${height}px` }
    }

    return { width: `${width}px`, height: `${height}px` }
  }

  return (
    <div className={styles["overlay"]}>
      <div style={getDimension()} className={getClass()} />
    </div>
  );
}
